import React from "react";
import { Paper, Table, TableBody, TableCell } from "@mui/material";
import { TableContainer, TableHead, TableRow } from "@mui/material";
import moment from "moment";

function PaymentReport({ items, onChange }) {
  return (
    <TableContainer component={Paper}>
      <Table aria-label="customized table">
        <TableHead>
          <TableRow>
            <TableCell className="fs-8">Selected</TableCell>
            <TableCell className="fs-8" sx={{ lineHeight: "1rem" }}>
              Type
            </TableCell>
            <TableCell className="fs-8">Amount</TableCell>
            <TableCell className="fs-8" sx={{ lineHeight: "1rem" }}>
               Payment By
            </TableCell>
            <TableCell className="fs-8">Received By</TableCell>
            <TableCell className="fs-8">Created</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {items?.map((item, i) => {
            return (
              <TableRow key={i}>
                <TableCell component="th" scope="row">
                  <input
                    type="checkbox"
                    defaultChecked=""
                    onChange={() => onChange(item)}
                  />
                </TableCell>
                <TableCell component="th" scope="row" className="fs-8">
                  {item?.type}
                </TableCell>
                <TableCell component="th" scope="row" className="fs-8">
                  {item?.amount}
                </TableCell>
                <TableCell component="th" scope="row" className="fs-8">
                  {item?.payer}
                </TableCell>
                <TableCell component="th" scope="row" className="fs-8">
                  {item?.receiver}
                </TableCell>
                <TableCell component="th" scope="row" className="fs-8">
                  {moment.unix(item?.created_at).format("DD-MM-YYYY")}
                </TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

export default PaymentReport;
